// src/utils/countries.js
export const ALLOWED_COUNTRY_CODES = ["TR", "CI", "SN", "NG"];

export const ALLOWED_COUNTRIES = [
  { code: "TR", name: "Turkey" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "SN", name: "Senegal" },
  { code: "NG", name: "Nigeria" },
];
